import { createRoot, hydrateRoot } from "react-dom/client";
import { Router, Route } from "./lib/router";
import { ThemeProvider } from "./lib/theme";
import { StaticDataProvider, getInitialStaticData } from "./lib/static-data";
import { AppDataProvider } from "./lib/app-data";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { Dashboard } from "./pages/Dashboard";
import { Accounts } from "./pages/Accounts";
import { Compose } from "./pages/Compose";
import { Posts } from "./pages/Posts";
import { Analytics } from "./pages/Analytics";
import { Inbox } from "./pages/Inbox";

const staticData = getInitialStaticData();

function App() {
  return (
    <ErrorBoundary>
    <StaticDataProvider data={staticData}>
      <ThemeProvider>
        <AppDataProvider>
        <Router>
          <Layout>
            <Route path="/login" component={Login} />
            <Route path="/register" component={Register} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password" component={ResetPassword} />
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/accounts" component={Accounts} />
            <Route path="/compose" component={Compose} />
            <Route path="/posts" component={Posts} />
            <Route path="/analytics" component={Analytics} />
            <Route path="/inbox" component={Inbox} />
          </Layout>
        </Router>
        </AppDataProvider>
      </ThemeProvider>
    </StaticDataProvider>
    </ErrorBoundary>
  );
}

const root = document.getElementById("root")!;

// If the root has SSR content, hydrate instead of mounting fresh
if (root.childNodes.length > 0 && (window as any).__STATIC_DATA__) {
  hydrateRoot(root, <App />);
} else {
  createRoot(root).render(<App />);
}
